
import mamovies from '../assets/mamovies.png';
import emaily from '../assets/emaily.png';

const LatestWork = ({ latestRef }) => {


    return (
        <div className='latest-work' ref={latestRef}>
            <div className='container work-container'>
                <h2>Latest Personal Projects</h2>
                <div className='row  '>
                    <div className='col-8 col-sm-6 col-lg-5 work-col'>
                        <div className='wrapper'>
                            <img src={mamovies} className='projectImg' alt='ProjectImg' />
                            <h3>
                                MaMovies
                            </h3>
                            <p>
                                Discover the latest Movies, Save Your Picks And More!
                            </p>
                            <p>
                                <a href='https://ma-movies.herokuapp.com' target="_blank" rel='noreferrer'>  MaMovies </a>
                            </p>
                        </div>
                    </div>
                    <div className='col-8 col-sm-6 col-lg-5 work-col'>
                        <div className='wrapper'>
                            <img src={emaily} className='projectImg' alt='ProjectImg' />
                            <h3>
                                Emaily
                            </h3>
                            <p>
                                Stay Connected To Your Clients And Send Feedbacks
                            </p>
                            <p>
                                <a href='https://protected-fortress-85047.herokuapp.com' target="_blank" rel='noreferrer'> Emaily </a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );

}

export default LatestWork;